module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Shield-disabled-911548bca04582523a6194b3fe55d306.svg";